// src/components/compliance/RaidUploadCard.jsx
// Thin wrapper — real implementation in shared/ui/FileDropzone.jsx.
import FileDropzone from "../../shared/ui/FileDropzone";
import { MAX_FILE_SIZE } from "../../utils/compliance/constants";

export default function RaidUploadCard({ onSubmit }) {
  return (
    <FileDropzone
      theme="legacy"
      accept={[".docx", ".pdf"]}
      maxTotalSize={MAX_FILE_SIZE}
      title="Upload SOW document"
      description={
        <>
          Accepted formats: <strong>.docx</strong> or <strong>.pdf</strong>.
          The AI will analyse the SOW and populate the RAID tracker with identified risks.
        </>
      }
      submitLabel="Analyse RAID Risks"
      submittingLabel="Uploading…"
      onSubmit={onSubmit}
    />
  );
}
